import React from 'react';
import { Link } from 'gatsby';

const Nav = () => {
  return (
    <div
      className=""
      data-aos="fade"
      data-aos-delay="10"
      data-aos-duration="1000"
    >
      <nav className="items-center hidden -mt-1 space-x-10 sm:flex">
        <Link
          to="/"
          data-aos="fade-down"
          data-aos-delay="10"
          data-aos-duration="1000"
        >
          Home
        </Link>
        <Link
          to="/#coverage-cities"
          data-aos="fade-down"
          data-aos-delay="10"
          data-aos-duration="1000"
        >
          Locations
        </Link>
        {/* <Link
          to="/why-jeetar/"
          className="flex items-center space-x-2 cursor-pointer"
          data-aos="fade-down"
          data-aos-delay="10"
          data-aos-duration="1000"
        >
          <span className=""> Partner with us</span>
          <img src={'/images/arrow-down.svg'} className='' alt='arrow-down' /> 
        </Link> */}
        <Link
          to="/#FAQ"
          data-aos="fade-down"
          data-aos-delay="10"
          data-aos-duration="1000"
        >
          FAQs
        </Link>
        <Link
          to="/about-us"
          data-aos="fade-down"
          data-aos-delay="10"
          data-aos-duration="1000"
        >
          About us
        </Link>
      </nav>
    </div>
  );
};

export default Nav;
